(function(scope,factory){const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;else scope.FASGardenCharms=api;})(typeof window==='undefined'?null:window,function(){
  'use strict';
  const TYPES=['Corazones','Animales','Deportes','Día de la Madre'];
  const cache=new WeakMap();
  function safeURL(value,base){try{const url=new URL(value,base);return typeof value==='string'&&/^https?:$/.test(url.protocol)&&!url.username&&!url.password?url.href:null;}catch(_){return null;}}
  function parseSources(value,base){
    if(typeof value==='string'){try{value=JSON.parse(value);}catch(_){return {};}}
    const result={};if(!value||typeof value!=='object')return result;
    for(const name of TYPES){
      const item=value[name],url=item&&safeURL(item.url,base);if(!url||!Array.isArray(item.patches))continue;
      const patches=item.patches.filter(p=>{
        if(!p||!Array.isArray(p.box)||p.box.length!==4||!p.box.every(Number.isFinite))return false;
        const[x,y,w,h]=p.box;if(x<0||y<0||w<=0||h<=0||x+w>1.00001||y+h>1.00001)return false;
        return p.ellipse===true||(Array.isArray(p.rings)&&p.rings.length>0&&p.rings.length<=5&&p.rings.every(r=>Array.isArray(r)&&r.length>=3&&r.length<=100&&r.every(v=>Array.isArray(v)&&v.length===2&&v.every(n=>Number.isFinite(n)&&n>=0&&n<=1))));
      }).slice(0,6);
      if(patches.length)result[name]={url,patches};
    }return result;
  }
  function anchors(pixels,width,height,target,count=16){
    if(!pixels||pixels.length<width*height*4)return [];
    const candidates=[],radius=target.height*.044;
    for(let y=target.y+target.height*.075;y<target.y+target.height*.94;y+=target.height*.043)for(let x=target.x+target.width*.06;x<target.x+target.width*.95;x+=target.width*.044){
      let solid=0;for(const [dx,dy] of [[0,0],[-.7,0],[.7,0],[0,-.7],[0,.7],[-.5,-.5],[.5,-.5],[-.5,.5],[.5,.5]]){const sx=Math.round(x+dx*radius),sy=Math.round(y+dy*radius);if(sx>=0&&sx<width&&sy>=0&&sy<height&&pixels[(sy*width+sx)*4+3]>220)solid++;}
      if(solid===9)candidates.push({x,y,size:radius*2});
    }
    const selected=[];
    for(let i=0;i<count;i++){
      const viable=candidates.filter(p=>selected.every(q=>Math.hypot(p.x-q.x,p.y-q.y)>radius*2.45));
      if(!viable.length)break;
      const idealX=target.x+target.width*.35,idealY=target.y+target.height*.12;
      const score=p=>selected.length?Math.min(...selected.map(q=>Math.hypot(p.x-q.x,p.y-q.y))):-Math.hypot(p.x-idealX,p.y-idealY);
      viable.sort((a,b)=>score(b)-score(a));
      selected.push({...viable[0],size:radius*2*(.88+(i%4)*.07)});
    }return selected;
  }

  function cutout(ctx,image,descriptor){
    let entries=cache.get(image);if(!entries){entries=new Map();cache.set(image,entries);}
    const key=JSON.stringify(descriptor);if(entries.has(key))return entries.get(key);
    const doc=ctx.canvas&&ctx.canvas.ownerDocument;if(!doc)return null;
    const[x,y,w,h]=descriptor.box,ratio=w*image.naturalWidth/(h*image.naturalHeight),canvas=doc.createElement('canvas');
    canvas.width=Math.max(1,Math.round(ratio>=1?180:180*ratio));canvas.height=Math.max(1,Math.round(ratio>=1?180/ratio:180));
    const c=canvas.getContext('2d');if(!c)return null;c.save();c.beginPath();
    if(descriptor.ellipse)c.ellipse(canvas.width/2,canvas.height/2,canvas.width/2-1,canvas.height/2-1,0,0,Math.PI*2);
    else descriptor.rings.forEach(ring=>{ring.forEach((p,i)=>{const px=p[0]*canvas.width,py=p[1]*canvas.height;if(i===0)c.moveTo(px,py);else c.lineTo(px,py);});c.closePath();});
    c.clip('evenodd');c.imageSmoothingEnabled=true;c.imageSmoothingQuality='high';
    c.drawImage(image,x*image.naturalWidth,y*image.naturalHeight,w*image.naturalWidth,h*image.naturalHeight,0,0,canvas.width,canvas.height);c.restore();entries.set(key,canvas);return canvas;
  }
  function draw(ctx,theme,target,width,height,record,descriptor){
    if(!TYPES.includes(theme)||!ctx||record?.state!=='ready'||!record.image||!descriptor?.patches?.length)return 0;
    try{
      const pixels=ctx.getImageData(0,0,width,height).data,points=anchors(pixels,width,height,target,16);let count=0;
      points.forEach((point,index)=>{
        const image=cutout(ctx,record.image,descriptor.patches[index%descriptor.patches.length]);if(!image)return;
        const scale=point.size/Math.max(image.width,image.height),w=image.width*scale,h=image.height*scale;
        ctx.save();ctx.globalCompositeOperation='source-atop';ctx.translate(point.x,point.y);ctx.rotate([-.14,.08,-.035,.18,.02][index%5]);
        ctx.shadowColor='rgba(38,24,13,.40)';ctx.shadowBlur=target.height*.003;ctx.shadowOffsetX=target.height*.0015;ctx.shadowOffsetY=target.height*.003;
        ctx.drawImage(image,-w/2,-h/2,w,h);ctx.restore();count++;
      });return count;
    }catch(_){return 0;}
  }
  return{anchors,parseSources,draw,types:TYPES.slice()};
});
